import Cookies from "js-cookie";
import pageTypeResolveService from "../services/PageTypeResolveService";
import browserSessionService, { SessionStartNotDefinedError } from "../services/BrowserSessionService";
import EshopConfiguration from "../services/EshopConfiguration";
import ajaxClient from "../../../js/common/AjaxClient";
import { assert } from "../../../js/common/assert";
import elementService from "@/common/ElementService";

interface HeaderBannerSecretResponse {
    readonly isSecretCode: boolean;
    readonly html: string | null;
}

export default new class PromoHeaderBarService {
    private static readonly ShownSecretCodeCookieName = "_sshn";

    public init(eshopConfiguration: EshopConfiguration): void {
        if (pageTypeResolveService.isCheckoutPage()) {
            return;
        }

        const headerBanner = document.querySelector<HTMLDivElement>("#js-header-banner");

        if (headerBanner === null) {
            return;
        }

        this.initCloseBannerButton(headerBanner, () => this.showSecretPromo(headerBanner));
        this.initShowSecretPromo(eshopConfiguration, headerBanner);
    }

    private initCloseBannerButton(headerBanner: HTMLDivElement, onClose?: () => Promise<void>): void {
        const closeButton = elementService.elementQuerySelector<HTMLButtonElement>(headerBanner, "#js-close-header-banner");

        closeButton.addEventListener("click", (event: MouseEvent) => {
            event.preventDefault();
            this.closeHeaderBanner(headerBanner, onClose);
        });
    }

    private closeHeaderBanner(headerBanner: HTMLDivElement, onClose?: () => Promise<void>): void {
        this.closeMobileSearchbar();
        this.hideHeaderBanner(headerBanner);

        if (onClose !== undefined) {
            void onClose();
        }
    }

    private closeMobileSearchbar(): void {
        const searchbarGap = document.querySelector<HTMLDivElement>("#js-mobile-searchbar");

        if (searchbarGap === null) {
            return;
        }

        searchbarGap.classList.remove("search-margin-set");
    }

    private hideHeaderBanner(headerBanner: HTMLDivElement): void {
        headerBanner.classList.add("hidden");
        Cookies.set("_phb", "1", { expires: 1 });
    }

    private initShowSecretPromo(eshopConfiguration: EshopConfiguration, headerBanner: HTMLDivElement): void {
        if (eshopConfiguration.isSecretEshopDiscountShown) {
            return;
        }

        try {
            const sessionStartTime = browserSessionService.getSessionStartTime();
            const showTime = new Date();
            showTime.setTime(sessionStartTime.setSeconds(sessionStartTime.getSeconds() + 90));
            const currentTime = new Date();

            if (showTime <= currentTime) {
                void this.showSecretPromo(headerBanner);

                return;
            }

            setTimeout(() => void this.showSecretPromo(headerBanner), showTime.getTime() - currentTime.getTime());
        } catch (error) {
            if (error instanceof SessionStartNotDefinedError) {
                // Ignore
            }

            throw error;
        }
    }

    private async showSecretPromo(headerBanner: HTMLDivElement): Promise<void> {
        const response = await ajaxClient.get<HeaderBannerSecretResponse>("/HeaderPromo/jsHeaderPromoSecret");

        if (!response.isSecretCode) {
            return;
        }

        assert(response.html !== null);

        headerBanner.innerHTML = response.html;
        this.initCloseBannerButton(headerBanner);
        Cookies.set(PromoHeaderBarService.ShownSecretCodeCookieName, this.getYMDDate(), { domain: ".odkarla.cz" });
    }

    private getYMDDate(): string {
        const today = new Date();
        const year = today.getFullYear().toString();
        let month = (today.getMonth() + 1).toString();
        let day = today.getDate().toString();

        if (month.length < 2) {
            month = `0${month}`;
        }

        if (day.length < 2) {
            day = `0${day}`;
        }

        return [year, month, day].join("-");
    }
}();
